"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
var structured_clone_1 = __importDefault(require("core-js-pure/actual/structured-clone"));
namespace_1.default.namespace.extend('model', function (frameId) {
    this.idPrefix = 'model';
    this.id = 'model';
    this.frameId = frameId; //	Has to be passed
    this.currentLevel = 0;
    this.maxLevel = 0;
    this.requiredData = { 0: [] }; //	Contains the data that is defined at the beginning and definitly won't change
    this.activeData = {}; //	Variable, contains all the data, that is loaded in the model, can change during different levels
    this.loadedData = {}; //	Contains the received, loaded data
    this.timestamps = {};
    this.updateHandlers = {};
    /*
        The init function has three jobs
            - Sets the first level of the activeData to the fist level of the requiredData
            - Binds events to listen to the kill event
            - Kicks on the loading process
    */
    this.init = function () {
        namespace_1.default.debug.showInfo('#' + this.frameId + ': Initializing model ' + this.id);
        this.activeData[0] = this.requiredData[0]; //	The required data-objects in level 0 can never be found through processing, they are fixed.
        this.bindEvents();
        this.getData();
    };
    this.bindEvents = function () {
        (0, jquery_1.default)(document).on(this.frameId + namespace_1.default.events.model.kill + this.id, this.killHandler = this.kill.bind(this));
        (0, jquery_1.default)(document).on(this.frameId + namespace_1.default.events.model.updateModel + this.id, this.updateModelHandler = this.updateModel.bind(this));
    };
    /*
        This function will be called when the model needs to be killed completely
            - Sets the current level to zero
            - Kills every data level
            - Kills the binding to the kill function
    */
    this.kill = function () {
        this.currentLevel = 0;
        this.killUpperLevels(0);
        (0, jquery_1.default)(document).off(this.frameId + namespace_1.default.events.model.kill + this.id, this.killHandler);
        (0, jquery_1.default)(document).off(this.frameId + namespace_1.default.events.model.updateModel + this.id, this.updateModelHandler);
    };
    /*
        - Kills all upper levels (above the first level because we don't want to decrease the "user" parameter below zero or affect another another model when initialized
        - Binds events and increases "user" parameter for currentLevel
        - Resets the loadedData for the currentLevel
        - Requests the data from the factory, depending on the currentLevel
    */
    this.getData = function () {
        var _this = this;
        if (this.currentLevel < this.maxLevel) {
            this.killUpperLevels(this.currentLevel + 1);
        }
        this.bindCurrentLevel();
        this.loadedData[this.currentLevel] = {};
        this.activeData[this.currentLevel].forEach(function (el) {
            var tDataObject = namespace_1.default.data.factory.getInstance(namespace_1.default.items[_this.frameId].config.namespace, el[0], el[1]);
            tDataObject.get();
        });
    };
    /*
        The controller can call this in order to update the model, e.g. when id's from data that has to be loaded have changed.
    */
    this.updateModel = function (ev) {
        this.killUpperLevels(0);
        this.currentLevel = 0;
        this.activeData = {};
        this.timestamps = {};
        this.activeData[0] = this.requiredData[0];
        this.checkData();
    };
    /*
        Kills all levels depending on the tLevel which is the first level to be killed
    */
    this.killUpperLevels = function (tLevel) {
        for (var i = tLevel; i <= this.maxLevel; i++) {
            this.killLevel(i);
        }
    };
    /*
        Kills one level which means:
            - Decreasing the "user" parameter from every data of this level by 1
            - Killing the update events of this level

    */
    this.killLevel = function (tLevel) {
        var _this = this;
        if (this.activeData[tLevel] && this.activeData[tLevel].length > 0) {
            this.activeData[tLevel].forEach(function (level) {
                var tDataId = level[0];
                if (level[1]) {
                    if (level[1] !== '')
                        tDataId += level[1];
                }
                var tDataObject = namespace_1.default.data.factory.getInstance(namespace_1.default.items[_this.frameId].config.namespace, level[0], level[1]);
                tDataObject.removeUser();
                (0, jquery_1.default)(document).off(namespace_1.default.items[_this.frameId].config.namespace + namespace_1.default.events.data.update + tDataId.replace(/\./g, ''), _this.updateHandlers[tDataId]);
                delete _this.updateHandlers[tDataId];
            });
            this.activeData[tLevel] = [];
        }
    };
    /*
        Binds one level which means:
            - Increasing the "user" parameter from every data of this level by 1
            - Binding the update events of this level
    */
    this.bindCurrentLevel = function () {
        var _this = this;
        this.activeData[this.currentLevel].forEach(function (item) {
            var tDataId = item[0];
            if ((item[1] && item[1] !== ''))
                tDataId += item[1];
            (0, jquery_1.default)(document).on(namespace_1.default.items[_this.frameId].config.namespace + namespace_1.default.events.data.update + tDataId.replace(/\./g, ''), _this.updateHandlers[tDataId] = _this.update.bind(_this));
            var tDataObject = namespace_1.default.data.factory.getInstance(namespace_1.default.items[_this.frameId].config.namespace, item[0], item[1]);
            tDataObject.addUser();
        });
    };
    /*
        - The update function is called whenever one data has been received.
        - Finds out the data level of the date which is received (tCurrentLevel)
        - Fills the loadedData array with the received data
        - If the level of the received data is beyond the "global" this.currentLevel, we resets the this.currentLevel to the tCurrentLevel
        - Calls the checkData function which checks if we have another level to load or if we are finished with all levels
    */
    this.update = function (ev) {
        var _this = this;
        var tUpdate = true;
        if (ev.dataId in this.timestamps) {
            if (this.timestamps[ev.dataId] === ev.lastUpdate) {
                tUpdate = false;
            }
            else {
                this.timestamps = {};
            }
        }
        if (tUpdate) {
            this.timestamps[ev.dataId] = ev.lastUpdate;
            var tCurrentLevel_1 = 0;
            Object.keys(this.activeData).forEach(function (index) {
                _this.activeData[index].forEach(function (data) {
                    var tId = data[0];
                    if (data[1])
                        tId += data[1];
                    if (tId == ev.dataId) {
                        tCurrentLevel_1 = parseInt(index, 10);
                    }
                });
            });
            /*
                LoadedData in the currentLevel has not to be deleted. (Only the data-object that kicked off the update will be replaced)
            */
            if (!this.loadedData[tCurrentLevel_1])
                this.loadedData[tCurrentLevel_1] = {};
            /*
                We have to delete the next level. Otherwise, the check in checkData will result in a full loadedData in this level.
                    Neventheless it is sufficient to delete the next level of loadedData. When this next level is loaded, the (afterwards) next level + 1 will be deleted.
            */
            if (this.loadedData[tCurrentLevel_1 + 1])
                this.loadedData[tCurrentLevel_1 + 1] = {};
            this.loadedData[tCurrentLevel_1][ev.dataId] = ev.content;
            if (tCurrentLevel_1 < this.currentLevel) {
                this.timestamps = {};
                this.timestamps[ev.dataId] = ev.lastUpdate;
                this.killLevel(tCurrentLevel_1 + 1);
                this.currentLevel = tCurrentLevel_1;
            }
            this.checkData(ev);
            if (namespace_1.default.debugmode) {
                this.updateDebugFrame(ev);
            }
        }
    };
    /*
        Checks by comparing the loadedData with the activeData if we are finished with this level
            - When finished:		checks if we are done with all levels
                - When done:		sends the data to the controller
                - When not done:
                    - Increases the this.currentLevel by 1
                    - Gets the next activeData level
                    - Calls the getData function which restarts loading the level
    */
    this.checkData = function (ev) {
        if (namespace_1.default.utils.getObjectSize(this.loadedData[this.currentLevel]) === this.activeData[this.currentLevel].length) {
            if (this.maxLevel == this.currentLevel) {
                this.sendUpdate();
            }
            else {
                this.currentLevel++;
                var hasNextLevel = this.getNextLevel();
                if (hasNextLevel) {
                    this.getData();
                }
                else {
                    this.sendUpdate();
                }
            }
        }
    };
    /*
        This function can be extended if needed

        e.g. when we got dependencies with more levels:

            switch(this.currentLevel) {

                case 0:

                    break;
                case 1:

                    break;
                ...
                    ...
                    ...
                default:

                    this.activeData[ this.currentLevel ] = this.requiredData[ this.currentLevel ];
                    break;
            }

        Important: If there is a case which does not need the next level, return false (@see checkData)
    */
    this.getNextLevel = function () {
        // default
        this.activeData[this.currentLevel] = this.requiredData[this.currentLevel];
        return true;
    };
    /*
        Calls the processData function to finally process the data
    */
    this.sendUpdate = function () {
        var defObj = jquery_1.default.Deferred();
        var tEvent = jquery_1.default.Event(this.frameId + namespace_1.default.events.model.send + this.id);
        tEvent.content = this.processData(this.mergeData(), defObj);
        defObj.then(function () {
            (0, jquery_1.default)(document).triggerHandler(tEvent);
        });
    };
    /*
        Merges the data from all levels to one data-object and returns it to the processData function
    */
    this.mergeData = function () {
        return (0, structured_clone_1.default)(Object.assign.apply(Object, __spreadArray([{}], Object.values(this.loadedData), false)));
    };
    /*
        This function can be extended if needed to process the data before sending it back to the model
    */
    this.processData = function (data, defObj) {
        defObj.resolve();
        return data;
    };
    this.updateDebugFrame = function (ev) {
        var element = document.getElementsByClassName('apa-loadeddata_' + this.frameId)[0];
        if (element) {
            element.innerHTML += '"' + this.id + '" requested: <a style="color:#88ff00;" href="' + ev.url + '">' + ev.url + '</a><br>';
        }
    };
});
